import { apiClient } from "@/lib/apiClient";

/**
 * Subscription Service - Following established patterns
 *
 * Available API endpoints:
 * - GET /api/v1/admin/:storeId/subscription/plan (current plan)
 * - GET /api/v1/admin/:storeId/subscription/plans (all available plans)
 * - POST /api/v1/admin/:storeId/subscription/upgrade (upgrade/change plan)
 * - POST /api/v1/admin/:storeId/subscription/downgrade (downgrade plan - optional)
 *
 * Plan pricing is included in the plans list, no need for cost calculations.
 * Wallet balance check is done client-side before API call.
 */

export interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  billing: "monthly" | "yearly";
  popular?: boolean;
  current?: boolean;
  status?: string;
  nextBilling?: string;
  features: {
    category: string;
    items: Array<{
      name: string;
      included: boolean | string | number;
    }>;
  }[];
}

export interface SubscriptionUpgradeRequest {
  planId: string;
  billingCycle: "monthly" | "yearly";
}

export interface SubscriptionUpgradeResponse {
  success: boolean;
  message: string;
  effectiveDate?: string;
  transactionId?: string;
}

// Get current subscription details
export const getCurrentSubscription = async () => {
  return await apiClient.get("/api/v1/admin/:storeId/subscription/plan");
};

// Get available plans
export const getAvailablePlans = async () => {
  return await apiClient.get("/api/v1/admin/:storeId/subscription/plans");
};

// Upgrade subscription
export const upgradeSubscription = async (data: SubscriptionUpgradeRequest) => {
  return await apiClient.post(
    "/api/v1/admin/:storeId/subscription/upgrade",
    data,
  );
};

// Downgrade subscription
export const downgradeSubscription = async (
  data: SubscriptionUpgradeRequest,
) => {
  return await apiClient.post(
    "/api/v1/admin/:storeId/subscription/downgrade",
    data,
  );
};

// Cancel subscription
export const cancelSubscription = async () => {
  return await apiClient.post("/api/v1/admin/:storeId/subscription/cancel");
};
